import PointsBalanceField, { PointsBalanceFieldProps } from "ui/wallet/components/input/PointsBalanceField/PointsBalanceField";
import useGetBalance from "ui/wallet/query/useGetBalance";

export type UserBalanceFieldProps = Omit<PointsBalanceFieldProps, "maxBalance">;

function UserBalanceField({ loading, validators, ...rest }: PointsBalanceFieldProps) {
    const { data: balanceUser = "0", isLoading } = useGetBalance();
    return <PointsBalanceField validators={{ lte: balanceUser, ...validators }} loading={loading || isLoading} {...rest} />;
}

export default UserBalanceField;
